import React from 'react';
import { WithTranslation, withTranslation } from 'react-i18next';

import { distances } from '../../../styles/constants';
import Card from '../../../components/Card';
import { H3 } from '../../../components/Typography';
import { OrderWithEvents, Order } from '../../../types/orders';
import ExternalIds from '../../common/ExternalIds';
import { Button } from '../../../components/Buttons';
import { getAuthorizableAmount, getCapturableAmount, getRefundableAmount, getCancelableAmount } from '../../helpers';
import styled from 'styled-components/macro';
import { Allow } from '../../../auth';

export interface OrderIdProps extends WithTranslation {
    order: OrderWithEvents;
    openAuthorize: (order: Order) => void;
    openCapture: (order: Order) => void;
    openRefund: (order: Order) => void;
    openCancel: (order: Order) => void;
}
const OrderId = (
    {
        t,
        order,
        openAuthorize,
        openCapture,
        openRefund,
        openCancel,
    }: OrderIdProps
) => {
    const authorizeAmount = getAuthorizableAmount(order as Order);
    const captureAmount = getCapturableAmount(order as Order);
    const refundAmount = getRefundableAmount(order as Order);
    const cancelAmount = getCancelableAmount(order as Order);
    const showButtonGroup =
        authorizeAmount + captureAmount + refundAmount + cancelAmount > 0 &&
        order.closed_at === undefined &&
        order.deleted_at === undefined;
    return (
        <Card marginBottom={distances.normal}>
            <H3>
                {t('orders.fields.order_id')}: {order.order_id}
            </H3>
            <ExternalIds draftOrOrder={order} />
            <Allow anyOfScopes={[['admin'], ['admin:shopping'], ['write:shopping']]}>
                <>
                    {showButtonGroup && (
                        <ButtonGroup>
                            {authorizeAmount > 0 && (
                                <Button className="alt tiny" onClick={() => openAuthorize(order as Order)}>
                                    {t('orders.order.operations.manual_authorize')}
                                </Button>
                            )}
                            {captureAmount > 0 && (
                                <Button className="alt tiny" onClick={() => openCapture(order as Order)}>
                                    {t('orders.order.operations.manual_capture')}
                                </Button>
                            )}
                            {refundAmount > 0 && (
                                <Button className="alt tiny" onClick={() => openRefund(order as Order)}>
                                    {t('orders.order.operations.manual_refund')}
                                </Button>
                            )}
                            {cancelAmount > 0 && (
                                <Button className="alt tiny" onClick={() => openCancel(order as Order)}>
                                    {t('orders.order.operations.manual_cancel')}
                                </Button>
                            )}
                        </ButtonGroup>
                    )}
                </>
            </Allow>
        </Card>
    );
};

const ButtonGroup = styled.div`
    margin-top: 16px;
    > button:not(:first-child) {
        margin-left: 8px;
    }
`;

export default withTranslation()(OrderId);
